/*!!
 * jQuery Scroll Undock 0.5
 * 
 * Jonatan Heyman | http://heyman.info
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 */
 
/* 
 * @name jQuery.scrollUndock
 * @projectDescription Undock an element and position it fixed on screen once the user scrolls past it
 * @author Jonatan Heyman | http://heyman.info
 * @version 0.5.0
 * @license MIT License
 * 
 * @id jQuery.scrollUndock
 * @param {jQuery Selector}: obj The element that should be undocked and fixed positioned on scroll
 * @param {Object} settings: Optional set of settings.
 *	 @option {Number} offset: Number of pixels from the top of the screen where the element should be fixed at
 *   @option {jQuery Selector} withinParent: Optional parent element that the undocked element should stay within
 *   @option {Number} bottomOffset: Used together with withinParent. Number of pixels from the bottom of the
 *                                  parent...
 *
 * @example $(".undockable").scrollUndock({});
 * @desc Undock the element
 */
;(function($){
    $.fn.scrollUndock = function(settings) {
        var settings = $.extend({}, $.scrollUndock.defaults, settings);
        var parent = (settings.withinParent ? $(settings.withinParent) : null);
        
        this.each(function() {
            var obj = $(this);
            var undockPoint;
            var undocked = false, bottomDocked = false;
            var placeholder;
            
            var origPos = obj.css("position");
            var origTop = obj.css("top");
            var origLeft = obj.css("left");
            var origWidth;
            
            var update = function() {
                var top = obj.offset().top - parseInt(obj.css('margin-top'), 10);
                var left = obj.offset().left - parseInt(obj.css('margin-left'), 10);
                
                var undock = function() {
                    // Inject a placeholder into the DOM
                    // This prevents other items from moving around when
                    // we undock.
                    placeholder = $('<div></div>')
                        .css({
                            'position': origPos,
                            'top': origTop,
                            'left': origLeft,
                            'width': obj.outerWidth(),
                            'height': obj.outerHeight(),
                            'margin-top': obj.css('margin-top'),
                            'margin-right': obj.css('margin-right'),
                            'margin-bottom': obj.css('margin-bottom'),
                            'margin-left': obj.css('margin-left'),
                            'z-index': 0
                        });
                    
                    origWidth = obj.css("width");
                    obj.css("width", obj.outerWidth());

                    obj.css("position", "fixed");
                    obj.css("top", settings.offset + "px");
                    obj.css("left", left + "px");
                    

                    if (!obj.css("z-index")) {
                        obj.css("z-index", 1);
                    }

                    obj.addClass('undocked');                    
                    placeholder.insertAfter(obj);
                    undocked = true;
                    bottomDocked = false;
                };
                var redock = function() {
                    // Remove the placeholder that has been maintaining the
                    // space the undocked item usually occupies in the DOM.
                    placeholder.remove();
                    placeholder = null;

                    obj.css("position", origPos);
                    obj.css("top", origTop);
                    obj.css("left", origLeft);
                    obj.css("width", origWidth);
                    obj.removeClass('undocked');
                    undocked = false;
                    bottomDocked = false;
                };
                var redockBottom = function() {
                    placeholder.remove();
                    placeholder = null;
                    
                    var newTop = parent.outerHeight() + parent.offset().top - obj.height() - settings.bottomOffset;
                    obj.css("position", "absolute");
                    obj.offset({top:newTop, left:left});
                    
                    bottomDocked = true;
                    undocked = false;
                };
                
                var windowScrollTop = $(window).scrollTop();
                
                if (!undocked && !bottomDocked && windowScrollTop > top-settings.offset) {
                    if (!parent || parent.height() - (obj.offset().top-parent.offset().top) > obj.height() + settings.offset + settings.bottomOffset + 1) {
                        undockPoint = top - settings.offset;
                        undock();
                    }
                }
                else if (parent && bottomDocked && windowScrollTop < obj.offset().top - settings.offset - parseInt(obj.css('margin-top'), 10))
                    undock();
                else if (parent && bottomDocked && (obj.offset().top - parent.offset().top + obj.height() + settings.bottomOffset) < parent.height())
                    // in case the parent has grown after we docked object to the bottom
                    undock();
                    
                if (undocked && windowScrollTop < undockPoint)
                    redock();
                if (parent && undocked && !bottomDocked && obj.offset().top > parent.height() + parent.offset().top - obj.height() - settings.bottomOffset)
                    redockBottom();
                
            };
            
            // throttle scroll event
            var onScroll = function() {
                $(window).unbind("scroll", onScroll);
                update();
                
                setTimeout(function() {
                    $(window).scroll(onScroll);
                    update();
                }, settings.scrollDelay);
            };
            $(window).scroll(onScroll);
            
            // run update on dom ready so that the element will be correctly positioned
            // if the page is reloaded when the user already scrolled
            $(document).ready(function() {
                update();
            });
            $(window).load(function() {
                update();
            });
        });
    };
    
    $.scrollUndock = {};
    
    // default settings
    $.scrollUndock.defaults = {
        offset: 0,
        withinParent: null,
        bottomOffset: 0,
        scrollDelay: 100
    };
})(jQuery);
